'use client';

export const RedCardTemplate = ({ redCardCount }: { redCardCount: number; }) => {
	return (
		<div className="vs__col">
			{redCardCount ? <div className="red-card">{redCardCount}</div> : null}
		</div>
	);
};
